import React, { useState } from "react";
import "./image.css";

export const Image = ({ title, largeImage, smallImage, text }) => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <>
      <div className="portfolio-item">
        <div className="hover-bg" onClick={togglePopup}>
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />
        </div>
      </div>
      {showPopup && (
        <div className="popup-overlay" onClick={togglePopup} id="modal">
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={togglePopup}>
              &times;
            </button>
            <h2 className="popup-title">{title}</h2>
            <div className="popup-body">
              <img src={largeImage} className="popup-image" alt={title} />
              <p className="popup-text">{text}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
